"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var OverviewActions = function OverviewActions(_ref) {
  var id = _ref.id,
      canEdit = _ref.canEdit,
      languageCode = _ref.languageCode;
  var editUrl = "/translation/edit?id=".concat(id);

  if (languageCode !== '') {
    editUrl = "/translation/edit?id=".concat(id, "&language=").concat(languageCode);
  }

  return (0, _preact.h)("div", {
    style: {
      whiteSpace: 'nowrap'
    }
  }, canEdit && (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(editUrl)
  }, (0, _preact.h)(_Button.default, {
    title: "Edit",
    variant: "secondary",
    size: "small"
  })));
};

var _default = OverviewActions;
exports.default = _default;